import React, { VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { makeSelectWhoami } from 'containers/Auth_old/selectors';
import { openScoreApplicantModal } from 'containers/GlobalPopup/actions';
import { useInjectReducer } from 'utils/injectReducer';

import { hideScorecardRequiredModal } from './actions';
import reducer from './reducer';
import { ScorecardRequiredModal as ScorecardRequiredModalComponent } from './ScorecardRequiredModal';
import { makeSelectScorecardRequirement } from './selectors';
import {
  ScorecardRequirementApplicant,
  ScorecardRequirementEvaluator,
} from './types';

// Mounted once beside GlobalPopup. Renders nothing until a move, reject, or
// bulk action is refused with a scorecard requirement; the refusing hook
// dispatches showScorecardRequiredModal with the server's payload.
const ScorecardRequiredModal: VFC = () => {
  useInjectReducer({ key: 'scorecardRequiredModal', reducer });
  const dispatch = useDispatch();
  const requirement = useSelector(makeSelectScorecardRequirement());
  const whoami = useSelector(makeSelectWhoami());

  if (!requirement) {
    return null;
  }

  const handleFillOutScorecard = (
    applicant: ScorecardRequirementApplicant,
    evaluator: ScorecardRequirementEvaluator,
  ) => {
    dispatch(hideScorecardRequiredModal());
    dispatch(
      openScoreApplicantModal({
        applicantId: applicant.id,
        scorecardTemplateId: String(evaluator.template.id),
        scorecardName: evaluator.template.name,
      }),
    );
  };

  return (
    <ScorecardRequiredModalComponent
      requirement={requirement}
      currentUserId={whoami?.external_id}
      onClose={() => dispatch(hideScorecardRequiredModal())}
      onFillOutScorecard={handleFillOutScorecard}
    />
  );
};

export default ScorecardRequiredModal;
